import { atom, useAtom } from 'jotai'
import { SetStateAction, useCallback } from 'react'
import { useUserState } from '~/atoms/UserState'
import useCloudwatchLogger from '~/hooks/useCloudwatchLogger'
import { SipClient } from '~/utils/sipclient'

const sipClientAtom = atom<SipClient | null>(null)
export interface SipInstanceResponse {
  triggerReregister: (boolean) => void
  sipInstance: [() => SipClient | null, (newClient: SipClient) => void]
}
export const useSipInstance = (): SipInstanceResponse => {
  const { logger } = useCloudwatchLogger('SipInstanceState')

  const [sipClient, setSipClient] = useAtom(sipClientAtom)
  const { currentUserExtensionId } = useUserState()

  const setSipInstance = useCallback((newSipClient: SipClient) => {
    logger?.debug('Sip instance created')
    setSipClient(newSipClient)
  }, [])

  const getSipInstance = useCallback(() => {
    return sipClient
  }, [sipClient])

  const triggerReregister = useCallback(
    (setNeedsReregister: (update: SetStateAction<boolean>) => void) => {
      logger?.debug('Sip re-register triggered')
      sipClient?.dispose()
      setSipClient(null)
      setNeedsReregister(true)
    },
    [sipClient, currentUserExtensionId],
  )

  return {
    triggerReregister,
    sipInstance: [getSipInstance, setSipInstance],
  }
}
